// import { JuristicBorrowFormContainer } from "../../../../containers/borrowSystem/BorrowForm/JuristicType/JuristicBorrowFormContainer"
import { AttatchFileTestContainer } from "../../../containers/borrowSystem/BorrowForm/AttatchFileTestContainer"
export function AttatchFileTestPage() {
    return (
        <AttatchFileTestContainer />
    )
}